@if(parsedDiff && parsedDiff.length) {
	<dx-data-grid height="100%" [dataSource]="parsedDiff" [columns]="columns" [columnAutoWidth]="true">
		<dxo-scrolling showScrollbar="onHover" [scrollByThumb]="true" [scrollByContent]="true"></dxo-scrolling>
		<div *dxTemplate="let rowData of 'cellTemplateSeparator'">
			<i class="fa-solid fa-arrow-right"></i>
		</div>

		<div *dxTemplate="let rowData of 'cellTemplateValue'">
			@let style = getValueStyle(rowData.data, rowData.column.dataField, rowData.data[rowData.column.dataField]);
			<span class="badge" [ngClass]="style.class">
				{{style.text}}
			</span>
		</div>
	</dx-data-grid>
}


